import {
  ClientSettingsPreferences,
  PreferenceKey,
  PreferenceScope,
} from '../data-models/preferences-v3.data-model';
import { PreferencesServiceV3 } from './preferences-service-v3';

export function getRoundLabel() {
  return isPrivateEquityClient() ? 'Tranche' : 'Round';
}

export function isPrivateEquityClient() {
  return PreferencesServiceV3.get().getPreference<ClientSettingsPreferences>(
    PreferenceKey.clientSettings,
    PreferenceScope.ORGANIZATION
  )?.isPrivateEquity;
}
